import { fetchFromUrlGETAsync } from '../fetch/'

export const actions = {
  getData: async () => {
    const result = await fetchFromUrlGETAsync('/feedback', [])
    return result.success ? result.data : []
  }
}
